/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Props for LoadingOverlay component.
 * @interface LoadingOverlayProps
 * @property {string} [message] - Optional loading message to display
 */
interface LoadingOverlayProps {
  message?: string;
}

/**
 * Full-screen loading overlay with spinner and optional message.
 * 
 * Features:
 * - Fixed position covering entire viewport
 * - Semi-transparent dark background
 * - White circular progress spinner (60px)
 * - Optional loading message below spinner
 * - Centered flex layout
 * - High z-index (9999) to overlay all content
 * - Bold message text
 * 
 * Use Cases:
 * - API request processing
 * - File uploads/downloads
 * - Long-running operations
 * - Page transitions
 * 
 * @param message - Text message displayed under spinner
 * @returns Full-screen loading indicator
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => {
  const { t } = useTranslation();
  
  return (
  <Box className="loading-overlay">
    <CircularProgress
      size={60}
      thickness={4}
      className="loading-spinner"
    />
    {message && (
      <Typography
        variant="h5"
        className="loading-message"
      >
        {message || t("loading.message")}
      </Typography>
    )}
  </Box>
  );
};

export default LoadingOverlay;